import React from "react";
import AssetTable from "./detailsAssetTable";
import DetailsTable from "./detailsTable";
import GraphComponent from "./graphComponent";

const DetailsComponent = ({
  viewDetails,
  viewInnerDetails,
  selectedDetail,
  setSelectedDetail,
  setViewInnerDetails,
  selectedAsset,
  setSelectedAsset,
  groupsData,
  detailBack,
}) => {
  return (
    <div>
      {!selectedAsset && (
        <AssetTable
          viewAssetDetails={viewDetails}
          onSelectAsset={setSelectedAsset}
        />
      )}

      {selectedAsset && !selectedDetail && (
        <DetailsTable
          viewInnerDetails={viewInnerDetails}
          onBack={() => detailBack()}
          onSelectDetail={setSelectedDetail}
          groupsData={groupsData}
        />
      )}

      {selectedAsset && !selectedDetail && (
        <GraphComponent
          graphDetails={viewInnerDetails}
          groupsData={groupsData}
        />
      )}
    </div>
  );
};

export default DetailsComponent;
